export default {
  computed: {
    country() {
      return this.$auth.loggedIn && this.$store.$auth.user?.country?.iso
        ? this.$store.$auth.user.country.iso
        : this.$store.state.country
    },
  },
}
